import fr from 'facet-rest';
import { DateInputLarge } from 'Packages/FacetDesign/Components/DateInput';
import { SelectInputLarge } from 'Packages/FacetDesign/Components/SelectInput';
import { TextInputLarge } from 'Packages/FacetDesign/Components/TextInput';
import { AutoCompleteInputLarge } from 'Packages/FacetDesign/Components/AutoCompleteInput';
import { EmailAddressInput } from 'Components/ComponentLibrary/Organisms/EmailAddressInput';
import { Progress } from 'Packages/FacetDesign/Components/Progress';

import { buildFacetDesignOverrideLite, overrideReadOnly } from './FacetDesignOverrideLite';

export { overrideReadOnly };

// This should never be exported. By making this only available via the function below we remove the possibility of
// this override getting accidentally adjusted downstream via directly importing it and amending with .override which
// will mutate the entire base override globally.
const baseOverride = buildFacetDesignOverrideLite()
  .typeOverride('date', { _component: () => DateInputLarge }, overrideReadOnly)
  .override({ hint: 'yearMonth' }, { _component: () => DateInputLarge, _customProps: { inputFormat: 'MM/YYYY' } }, overrideReadOnly)
  .typeOverride('picklist', { _component: () => SelectInputLarge }, overrideReadOnly) // TODO: Support required
  .override({ type: 'picklist', readonly: true }, { _component: () => TextInputLarge }, overrideReadOnly) // At the time of writing, disabled meta picklists do not receive options, which breaks FDSelectInput - use TextInputLarge instead so that this isn't broken
  .override({ hint: 'autocomplete' }, { _component: () => AutoCompleteInputLarge }, overrideReadOnly)
  // TODO: Need FacetDesign input for hint: zipcode
  .typeOverride('multipicklist', {
    _component: () => SelectInputLarge,
    _customProps: { multiple: true },
  }, overrideReadOnly)
  .override({ type: 'multipicklist', hint: 'autocomplete' }, {
    _component: () => AutoCompleteInputLarge,
    _customProps: { multiple: true },
  }, overrideReadOnly)
  .override({ type: 'multipicklist', readonly: true }, { _component: () => TextInputLarge }, overrideReadOnly) // At the time of writing, disabled meta multipicklists do not receive options, which breaks FDSelectInput - use TextInputLarge instead so that this isn't broken

  .override({
    hint: 'progressBar',
    readonly: true,
  }, {
    _component: () => Progress,
    _customProps: {
      icon: 'star',
    },
  }, overrideReadOnly)
  .nameOverride('emailAddresses', { _component: () => EmailAddressInput }, overrideReadOnly)

  .done();


export const buildFacetDesignOverride = () => fr.metaOverride({ base: baseOverride });
